import {
  FileOutlined,
  UserOutlined,
  ScheduleOutlined,
  UsergroupAddOutlined,
  CarryOutOutlined,
  OrderedListOutlined,
  SettingOutlined,
  MessageOutlined,
  FileSearchOutlined,
  SmileOutlined,
  HeartOutlined,
  BookOutlined,
  PushpinOutlined,
  HomeOutlined,
  TrophyOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import {
  useWindowSize,
  useWindowWidth,
  useWindowHeight,
} from "@react-hook/window-size";
import { Avatar, Badge, Space } from "antd";
import { Breadcrumb, Layout, Menu, theme, Image } from "antd";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Docs from "./Docs";
import { useSelector } from "react-redux";
import { getDataDoc } from "../database";
import { testSlice } from "../redux/store";
import Chats from "../Pages/Chats/View";
import { useDispatch } from "react-redux";
import MobileBottomNavigation from "./MobileBottomNavigation";
import "./MobileNavigation.css";
const { actions } = testSlice;
const { GET_USER, SESSION } = actions;

const { Header, Content, Footer, Sider } = Layout;
function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}

const NavbarElev = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [width, height] = useWindowSize();
  const [open, setOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const isMobile = width <= 768;
  const items = [
    user.mode === "hybrid" && getItem("Mod profesor", "profesor"),
    getItem("Note", "elev-catalog", <CarryOutOutlined />),
    getItem("Orar", "orar", <ScheduleOutlined />),
    getItem("Anunțuri", "anunturi", <CarryOutOutlined />),

    getItem("Teme", "teme", <FileOutlined />),
    getItem("Comentarii", "comentarii-elev", <PushpinOutlined />),
    getItem("Scutiri", "scutiri-elev", <HeartOutlined />),

    getItem("Lecții", "lectii-elev", <BookOutlined />),

    getItem("Profil", "profil", <SmileOutlined />),
  ];


  if (isMobile) {
    return (
      <>
        <div className={`mobile-overlay ${mobileMenuOpen ? 'open' : ''}`} onClick={() => setMobileMenuOpen(false)} />
        <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
          <div className="mobile-menu-header">
            <img
              src={process.env.REACT_APP_LOGO}
              alt="Logo"
              className="mobile-menu-logo"
              onClick={() => navigate("/")}
            />
            <div className="mobile-menu-close" onClick={() => setMobileMenuOpen(false)}>×</div>
          </div>
          <Menu
            onClick={async (e) => {
              setMobileMenuOpen(false);
              if (e.key === "profesor") {
                let u = await getDataDoc("users", user.id || user.uid);
                dispatch(
                  GET_USER({
                    ...user,
                    ...u,
                    type: "profesor",
                    mainType: "profesor",
                    copii: [],
                    id: user.oldUid,
                    uid: user.oldUid,
                  })
                );
                navigate("/");
                return;
              }
              if (e.key === "mesaje") setOpen(true);
              else navigate("/" + e.key);
            }}
            theme="light"
            mode="inline"
            items={items}
            className="mobile-menu-items"
          />
        </div>
        <MobileBottomNavigation userType="elevi" onMenuOpen={setMobileMenuOpen} />
        <Chats open={open} setOpen={setOpen} />
      </>
    );
  }

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
      breakpoint="lg"
      collapsedWidth={70}
    >
      <Chats open={open} setOpen={setOpen} />
      <div
        style={{ width: "200px", display: "flex", justifyContent: "center" }}
      >
        {" "}
        {collapsed === false && (
          <Image
            width={100}
            height={100}
            src={process.env.REACT_APP_LOGO}
            preview={false}
            onClick={() => {
              navigate("/");
            }}
          />
        )}
      </div>

      <Menu
        onClick={async (e) => {
          if (e.key === "profesor") {
            let u = await getDataDoc("users", user.id || user.uid);
            dispatch(
              GET_USER({
                ...user,
                ...u,
                type: "profesor",
                mainType: "profesor",
                copii: [],
                id: user.oldUid,
                uid: user.oldUid,
                // Suprascrie datele cu cele ale profesorului pentru a fi folosite când adaugă note
                displayName: u.displayName,
                adresaEmail: u.adresaEmail,
                numeDeFamilie: u.numeDeFamilie,
                prenume: u.prenume,
                photoLink: u.photoLink,
              })
            );
            navigate("/");
            return;
          }
          if (e.key === "mesaje") setOpen(true);
          else navigate("/" + e.key);
        }}
        theme="dark"
        defaultSelectedKeys={["1"]}
        mode="inline"
        items={items}
      />
    </Sider>
  );
};
export default NavbarElev;
